import type { FC } from "react";
import { Button, type ButtonProps } from "shared/components/Spor";

type ActionCardButtonProps = Omit<
  ButtonProps,
  "fontSize" | "fontWeight" | "lineHeight" | "size" | "variant"
> & {
  variant: "primary" | "secondary" | "tertiary";
};

export const ActionCardButton: FC<ActionCardButtonProps> = ({
  variant,
  ...props
}) => <Button {...props} variant={variant} size="xs" />;
